import { User } from '../types';

const getDealId = (): string => {
  const { pathname } = window.location;

  let dealId = '';

  if (pathname) {
    const isDealsDetailCheck = pathname.includes('deals/');
    const pathLength = pathname.split('/').length;
    const slicedDealId = isDealsDetailCheck
      ? pathname.split('/')[pathLength - 1]
      : '';

    dealId = slicedDealId;
  }

  return dealId;
};

const getIdsForEngagement = () => {
  const { pathname } = window.location;

  let engagementId = '';

  let branchId = '';

  if (pathname) {
    const isEngagements =
      pathname.includes('engagements') && pathname.includes('threads');

    const pathLength = pathname.split('/').length;

    engagementId = isEngagements ? pathname.split('/')[pathLength - 3] : '';

    branchId = isEngagements ? pathname.split('/')[pathLength - 1] : '';
  }

  return { engagementId, branchId };
};

export const getCurrentPath = (path: string, user: User | null): string => {
  let resultPath = path;

  const dealId = getDealId();

  const { engagementId, branchId } = getIdsForEngagement();

  if (engagementId.length && branchId.length) {
    resultPath = path
      .replace(':orgId', user?.orgId || '')
      .replace(':userId', user?.userId || '')
      .replace(':engagementId', engagementId)
      .replace(':branchId', branchId);
  } else if (dealId?.length) {
    resultPath = path
      .replace(':orgId', user?.orgId || '')
      .replace(':userId', user?.userId || '')
      .replace(':dealId', dealId);
  } else {
    resultPath = path
      .replace(':orgId', user?.orgId || '')
      .replace(':userId', user?.userId || '');
  }

  return resultPath;
};
